import React from 'react';
import Box from '@mui/material/Box';
import { LinearProgress, Typography } from '@mui/material';

import { DataGrid, esES } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setDashboardNodeSelected } from '../../../store/fuse/dashboard';

import { setProgressBarColor } from '../utils';



const DownNodes = () => {
  const data = useSelector((state) => state?.fuse?.dashboard?.dashboard?.irregularNodes.unavailable);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const currentMetricThresholds = useSelector((state) => state?.fuse?.dashboard?.metricThresholds);

  const columns = [
    {
      field: 'dsnodo',
      headerName: 'Nodo',
      height: 10,
      customHeadRender: () => null,
      flex: 1,
    },
    {
      field: 'disponibilidad',
      headerName: 'Disponibilidad',
      sortable: false,
      width: 250,
      align: 'left',
      renderCell: (params) => {
        const value = Number(params.row?.disponibilidad);
        const [progressBarColor, progressBarLabelColor] = setProgressBarColor(value, 'disponibilidad', currentMetricThresholds);
        return (
          <Box display="flex" flexDirection="row" alignItems="center" sx={{ width: '100%' }}>
            <Box sx={{ width: '80%', mr: 1 }}>
              <LinearProgress variant="determinate" color={progressBarColor} value={Number(params.row?.disponibilidad) || 0} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2" color={progressBarLabelColor}>{`${Number(params.row?.disponibilidad)}%`}</Typography>
            </Box>
          </Box>
        );
      },
    },
  ];

  const handleRowClick = (row) => {
    dispatch(setDashboardNodeSelected('/dashboard', row.row.dsnodo));
    navigate(`/dashboard/${row.row.nodeId}`);
  };
  return (
    <div
      className="flex max-w-full gap-0 m-10 rounded-lg flex-col"
      style={{ height: '565px', backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}
    >
      <strong className="title-chart" style={{ marginTop: '10px', marginBottom: '10px' }}>
        Disponibilidad de Nodos
      </strong>
      <DataGrid
        localeText={{
          noRowsLabel: 'No hay nodos', // You can customize this string
        }}
        headerHeight={0}
        rows={data}
        columns={columns}
        disableRowSelectionOnClick
        hideFooter
        onRowClick={handleRowClick}
      />
    </div>
  )
}

export default DownNodes;
